import React, { createContext, useContext } from "react"

import { useMessages } from "@shared/hooks"
import { Message } from "@shared/hooks/useMessages"
import { FirebaseRef } from "@shared/modules"

const messagesContext = createContext<MessagesContext>({
  messages: [],
  managerMessages: [],
  keyword: "",
  positions: [],
  lastStreamerMessage: undefined,
  sentViewer: [],
  isMentionAlert: false,
})
const handleMessagesContext = createContext<HandleMessagesContext>({
  send: () => {},
  search: () => {},
})

interface Props {
  limitCount?: number
  firebaseRef?: FirebaseRef
  children?: React.ReactNode
}

function MessagesProvider({
  limitCount = 100,
  firebaseRef = "messages",
  children,
}: Props) {
  const { send, search, ...rest } = useMessages({ limitCount, firebaseRef })

  return (
    <messagesContext.Provider value={rest}>
      <handleMessagesContext.Provider value={{ send, search }}>
        {children}
      </handleMessagesContext.Provider>
    </messagesContext.Provider>
  )
}

function useMessagesContext() {
  return useContext(messagesContext)
}

function useHandleMessagesContext() {
  return useContext(handleMessagesContext)
}

export { MessagesProvider, useMessagesContext, useHandleMessagesContext }

interface MessagesContext {
  messages: Message[]
  managerMessages: Message[]
  keyword?: string
  positions: string[]
  lastStreamerMessage?: Message
  sentViewer: string[]
  isMentionAlert: boolean
}

interface HandleMessagesContext {
  send: (message: Message) => void
  search: (keyword: string) => void
}
